import { render, staticRenderFns } from "./lawIssue.vue?vue&type=template&id=5af8f0af&scoped=true&"
import script from "./lawIssue.vue?vue&type=script&lang=js&"
export * from "./lawIssue.vue?vue&type=script&lang=js&"
import style0 from "./lawIssue.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lawIssue.vue?vue&type=style&index=1&id=5af8f0af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8f0af",
  null
  
)

export default component.exports